import React from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8"
        >
            <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
                <div className="bg-yellow-500 py-6 px-8">
                    <h1 className="text-3xl font-bold text-white">Conditions Générales d’Utilisation (CGU)</h1>
                    <p className="text-yellow-100 mt-2">Dernière mise à jour : 26 novembre 2025</p>
                </div>

                <div className="p-8 space-y-8 text-gray-600 dark:text-gray-300">
                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">1. Objet</h2>
                        <p>Les présentes Conditions Générales d’Utilisation (CGU) régissent l’accès et l’utilisation du site Tekhdem.com (ci-après « le Site »), propriété de Tekhdem SARL, immatriculée en Algérie.</p>
                        <p className="mt-2">Le Site permet la mise en relation des candidats et des entreprises pour des offres d’emploi.</p>
                        <p className="mt-2">L’utilisation du Site implique l’acceptation sans réserve des présentes CGU.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">2. Acceptation des Conditions</h2>
                        <p>En accédant au Site, vous acceptez pleinement les présentes CGU.</p>
                        <p className="mt-2">Si vous n’acceptez pas ces CGU, vous ne devez pas utiliser le Site.</p>
                        <p className="mt-2">Tekhdem.com se réserve le droit de demander la confirmation de votre acceptation des CGU à tout moment.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">3. Accès au Site</h2>
                        <p>Le Site est accessible 24h/24 et 7j/7, sauf en cas de maintenance ou de force majeure.</p>
                        <p className="mt-2">Tekhdem.com peut suspendre ou interrompre temporairement l’accès au Site pour maintenance, mise à jour ou tout motif légitime.</p>
                        <p className="mt-2">L’utilisateur est responsable de son matériel et de sa connexion internet.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">4. Compte Utilisateur</h2>
                        <ul className="list-disc ml-5 space-y-1">
                            <li>La création d’un compte est obligatoire pour certaines fonctionnalités (postuler, publier des offres, suivre candidatures).</li>
                            <li>Les informations fournies doivent être exactes, complètes et à jour.</li>
                            <li>L’utilisateur est responsable de la confidentialité de son identifiant et mot de passe, ainsi que de toutes les actions effectuées via son compte.</li>
                            <li>Tekhdem.com peut suspendre, restreindre ou supprimer un compte en cas de violation des CGU ou de comportement frauduleux.</li>
                            <li>L’utilisateur peut supprimer son compte à tout moment, sous réserve que toutes les obligations en cours soient respectées.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">5. Contenu Utilisateur</h2>
                        <p>Les utilisateurs restent propriétaires de leurs contenus (CV, offres, messages), mais accordent à Tekhdem.com une licence mondiale, gratuite, non exclusive et transférable pour exploiter le contenu dans le cadre des services.</p>
                        <p className="mt-2 font-semibold">L’utilisateur garantit que son contenu :</p>
                        <ul className="list-disc ml-5 mt-1 space-y-1">
                            <li>Ne viole aucun droit d’auteur ou propriété intellectuelle.</li>
                            <li>Ne contient pas de propos diffamatoires, offensants, discriminatoires ou illégaux.</li>
                        </ul>
                        <p className="mt-2">Tekhdem.com se réserve le droit de modérer, supprimer ou suspendre tout contenu jugé inapproprié, sans préavis.</p>
                        <p className="mt-2">Tekhdem.com ne peut être tenu responsable des conséquences du contenu publié par les utilisateurs.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">6. Propriété Intellectuelle</h2>
                        <p>Tous les contenus du Site (textes, logos, images, vidéos, logiciels, bases de données) sont la propriété exclusive de Tekhdem.com ou de ses partenaires et sont protégés par la législation algérienne et internationale.</p>
                        <p className="mt-2">Toute reproduction, diffusion, modification, adaptation ou exploitation commerciale non autorisée est strictement interdite.</p>
                        <p className="mt-2">Toute utilisation du Site à des fins commerciales requiert l’accord écrit préalable de Tekhdem.com.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">7. Responsabilité Limitée</h2>
                        <p className="font-semibold">Tekhdem.com ne peut être tenu responsable :</p>
                        <ul className="list-disc ml-5 mt-1 space-y-1">
                            <li>Des erreurs ou omissions dans les informations publiées par les utilisateurs.</li>
                            <li>Des interruptions, dysfonctionnements, virus ou pertes de données liés au Site.</li>
                            <li>De la qualité ou fiabilité des services des entreprises ou candidats via le Site.</li>
                        </ul>
                        <p className="mt-2">L’utilisation du Site se fait à vos risques et périls.</p>
                        <p className="mt-2">Tekhdem.com n’est pas responsable des dommages indirects ou immatériels tels que perte de revenus, perte de données ou préjudice commercial.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">8. Liens Externes</h2>
                        <p>Le Site peut contenir des liens vers des sites tiers.</p>
                        <p className="mt-2">Tekhdem.com n’exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leurs pratiques.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">9. Paiement (si applicable)</h2>
                        <p>Les offres payantes ou services premium feront l’objet d’un contrat distinct précisant les tarifs et conditions de paiement.</p>
                        <p className="mt-2">Les paiements effectués sont non remboursables sauf disposition contraire du contrat ou obligation légale.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">10. Suspension et Résiliation</h2>
                        <p>Tekhdem.com peut suspendre ou résilier votre accès en cas de violation des CGU, sans préavis ni indemnité.</p>
                        <p className="mt-2">La résiliation n’affecte pas les obligations légales ou financières existantes.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">11. Force Majeure</h2>
                        <p>Tekhdem.com n’est pas responsable des manquements ou retards résultant d’événements échappant à son contrôle, tels que catastrophes naturelles, conflits, pannes techniques, cyberattaques ou interruptions du réseau internet.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">12. Modification des CGU</h2>
                        <p>Tekhdem.com peut modifier les CGU à tout moment. Les modifications seront publiées sur le Site avec la date de mise à jour. L’usage continu du Site implique l’acceptation des nouvelles CGU.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">13. Loi Applicable et Juridiction</h2>
                        <p>Les présentes CGU sont régies par le droit algérien. Tout litige relatif à l’interprétation ou l’exécution sera soumis aux tribunaux compétents en Algérie.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">14. Contact</h2>
                        <p>Pour toute question concernant ces CGU, vous pouvez nous contacter :</p>
                        <div className="mt-2 bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                            <p><strong>Email :</strong> contact@tekhdem.com</p>
                            <p><strong>Adresse :</strong> Alger, Algérie</p>
                        </div>
                    </section>

                    <div className="pt-8 text-center text-sm text-gray-500 border-t border-gray-200 dark:border-gray-700">
                        <p>© {new Date().getFullYear()} Tekhdem.com - Tous droits réservés.</p>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default Terms;
